import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { userLoggedOut } from "../auth/authSlice";
import { ErrorGroupFilter } from "@api/core/logistics/sales-orders/sales-orders.schema";
import { GroupedInvoicesSchema } from "@api/core/logistics/invoices/invoices.schema";

type InvoiceDetailsState = {
  invoiceErrorGroups: ErrorGroupFilter | undefined;
  groupedInvoiceDetails: GroupedInvoicesSchema | undefined;
};

const initialState: InvoiceDetailsState = {
  invoiceErrorGroups: undefined,
  groupedInvoiceDetails: undefined,
};

const invoiceDetailsSlice = createSlice({
  name: "invoiceDetails",
  initialState,
  reducers: {
    setInvoiceErrorGroups: (state, action: PayloadAction<ErrorGroupFilter | undefined>) => {
      state.invoiceErrorGroups = action.payload;
    },
    setGroupedInvoiceDetails: (state, action: PayloadAction<GroupedInvoicesSchema | undefined>) => {
      state.groupedInvoiceDetails = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(userLoggedOut, (_) => {
      return initialState;
    });
  },
});

export const { setInvoiceErrorGroups, setGroupedInvoiceDetails } =
  invoiceDetailsSlice.actions;

export const selectInvoiceErrorGroups = (state: RootState) =>
  state.invoiceDetails.invoiceErrorGroups;
export const selectGroupedInvoiceDetails = (state: RootState) =>
  state.invoiceDetails.groupedInvoiceDetails;

export default invoiceDetailsSlice.reducer;
